const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`55bd3c325bc73c21be28ca268f29cf179dac4a6a487b09d406b419cccb6c2e6a`, `55bd3c325bc73c21be28ca268f29cf179dac4a6a487b09d406b419cccb6c2e6a`, 1, 98), undefined, true, false, 1));
            }

            getTemplateName() {
                return `55bd3c325bc73c21be28ca268f29cf179dac4a6a487b09d406b419cccb6c2e6a`;
            }

            getSourceContext() {
                return new this.Source(``, `55bd3c325bc73c21be28ca268f29cf179dac4a6a487b09d406b419cccb6c2e6a`, ``);
            }
        }],
        [98, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/button-group/button-group.twig`, `55bd3c325bc73c21be28ca268f29cf179dac4a6a487b09d406b419cccb6c2e6a`, 1);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/button-group/button-group.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                context.set('_parent', context.clone());

                (() => {
                    let c = this.ensureTraversable(this.createRange(1, (context.has(`count`) ? context.get(`count`) : null)));

                    if (c === context) {
                        context.set('_seq', context.clone());
                    }
                    else {
                        context.set('_seq', c);
                    }
                })();

                context.set('loop', new Map([
                  ['parent', context.get('_parent')],
                  ['index0', 0],
                  ['index', 1],
                  ['first', true]
                ]));
                if ((typeof context.get('_seq') === 'object') && this.isCountable(context.get('_seq'))) {
                    let length = this.count(context.get('_seq'));
                    let loop = context.get('loop');
                    loop.set('revindex0', length - 1);
                    loop.set('revindex', length);
                    loop.set('length', length);
                    loop.set('last', (length === 1));
                }
                this.iterate(context.get('_seq'), (__key__, __value__) => {
                    context.proxy[`_key`] = __key__;
                    context.proxy[`i`] = __value__;
                    this.echo(`      `);
                    this.echo(this.include(context, this.source, this.loadTemplate(`55bd3c325bc73c21be28ca268f29cf179dac4a6a487b09d406b419cccb6c2e6a`, `55bd3c325bc73c21be28ca268f29cf179dac4a6a487b09d406b419cccb6c2e6a`, 4, 97), undefined, true, false, 4));
                    this.echo(`    `);
                    (() => {
                        let loop = context.get('loop');
                        loop.set('index0', loop.get('index0') + 1);
                        loop.set('index', loop.get('index') + 1);
                        loop.set('first', false);
                        if (loop.has('length')) {
                            loop.set('revindex0', loop.get('revindex0') - 1);
                            loop.set('revindex', loop.get('revindex') - 1);
                            loop.set('last', loop.get('revindex0') === 0);
                        }
                    })();
                });
                (() => {
                    let parent = context.get('_parent');
                    context.delete('_seq');
                    context.delete('_iterated');
                    context.delete('_key');
                    context.delete('i');
                    context.delete('_parent');
                    context.delete('loop');
                    for (let [k, v] of parent) {
                        if (!context.has(k)) {
                            context.set(k, v);
                        }
                    }
                })();
                this.echo(`  `);
            }

            getTemplateName() {
                return `55bd3c325bc73c21be28ca268f29cf179dac4a6a487b09d406b419cccb6c2e6a`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `55bd3c325bc73c21be28ca268f29cf179dac4a6a487b09d406b419cccb6c2e6a`, ``);
            }
        }],
        [97, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/button/button.twig`, `55bd3c325bc73c21be28ca268f29cf179dac4a6a487b09d406b419cccb6c2e6a`, 4);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/button/button.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`Button `);
                this.echo(this.env.getFilter('escape').traceableCallable(5, this.source)(...[this.env, (context.has(`i`) ? context.get(`i`) : null), `html`, null, true]));
            }

            getTemplateName() {
                return `55bd3c325bc73c21be28ca268f29cf179dac4a6a487b09d406b419cccb6c2e6a`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `55bd3c325bc73c21be28ca268f29cf179dac4a6a487b09d406b419cccb6c2e6a`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '55bd3c325bc73c21be28ca268f29cf179dac4a6a487b09d406b419cccb6c2e6a');

let template = env.loadTemplate('55bd3c325bc73c21be28ca268f29cf179dac4a6a487b09d406b419cccb6c2e6a');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/objects/button-group/demo/demo.twig", args: context }
     );
     return rendered;;
};